// extracted by mini-css-extract-plugin
module.exports = {"bell":"style_bell__8zJlx"};